var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonCarousel',{attrs:{"aria-label":_vm.$t('main.common.carousel.carouselPreviousAriaLabel')},on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{staticClass:"invert",attrs:{"icon":"arrow","color":"white","width":12,"height":12}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }